import script from "./RouteContext.vue?vue&type=script&lang=js"
export * from "./RouteContext.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__